var Blog = $.extend(false, BaseModule ,{

    api_route : 'blog',

    data : {
        module      : 'blog',
        page        : 1,
        limit            : 20,
        sort_term   : 'id',
        sort_way    : 'DESC',
        details_with: 'file:products',
        view        : 'grid',
        pagination  : true
    },

    keydownTimer:null,

    execute_import:function(f){
        var module_name = this.data.module;
        var module = this;
        $.ajax({data:$('form[name="'+module_name+'_form"]').serialize(),success:function(data){
            if(data.status == 'ok'){
                module.load_list();
            }else{
                show_message('nFailure',data.error);
            }
        }});
    },
    
    import_form:function(data){
        var module_name = this.data.module,
            module = this;
            
        $("#import-dialog").on('shown.bs.modal', function () {

            $("#import-dialog .btn-ok").on('click',function(){
                var $files = [];
                $('#import-dialog input[name="filename[]"]').each(function(){
                    var v = $(this).val();
                    $files.push(v);
                });
                $.ajax({
                    url : API + 'blog/import',
                    data:{
                        files : $files
                    },
                    type:'PUT',
                    error:function(){
                        GlobalModule.show_message('danger','Something went wrong');
                    },
                    success:function(data){

                        GlobalModule.show_message('success','Successfuly submited. Import information is not available');

                    }
                });
                $("#import-dialog").modal('hide');

            });
            initForm('#import-dialog');

        }).on('hidden.bs.modal', function () {
            
            module.load_list();

        }).modal('show');

    },
    before_save:function(){
        var module_name = this.data.module;
        Builder.set_target($('form[name="'+module_name+'_form"]')).commit();
    },

    after_load_entry:function(){
        "use strict";
        var module_name = this.data.module;
        this.save();
        Builder.set_target($('form[name="'+module_name+'_form"]')).setup();
    },

    init:function(){
        var module_name = this.data.module,module = this;
    }
});

$(document).ready(function(){
    "use strict";
    Blog.init();
});
